<template>
    <div>
        <span class="data-label">
            {{ forceLabel ? forceLabel : label }}
            <i
                v-if="useFavorite"
                :class="['blue ml-2 fs-2 cpointer data-label-icon-toggle', isFavoriteClass]"
                @click.prevent="toggleFavorite"
            ></i>
            <i
                v-if="canRemoveFavorite"
                class="icon-close primary-50 ml-2 fs-2 cpointer"
                @click.prevent="toggleFavorite"
            ></i>
        </span>
        <span :class="['data-value', canRemoveFavoriteClass]" v-html="valueComputed" />
    </div>
</template>

<script>
import FavoriteHeaderMixins from '../../../../mixins/FavoriteHeaderMixins';
import DataValueMixin from '../../../../mixins/DataValueMixins';

export default {
    mixins: [FavoriteHeaderMixins, DataValueMixin],

    computed: {
        valueComputed() {
            return this.value.replace(/\n/g, '<br>');
        },
    },
};
</script>
